import { IconButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import type { SignalType } from "app/pages/sales-intelligence/domain/signals/types/signal";

import { StyledAddSignalButtonWrapper } from "./styles";

type AddSignalButtonProps = {
    className?: string;
    signalType: SignalType;
    onClick(): void;
};

const AddSignalButton = (props: AddSignalButtonProps) => {
    return (
        <StyledAddSignalButtonWrapper
            className={props.className}
            justifyContent="center"
        >
            <IconButton
                dataAutomation="add-signal-button"
                iconName="add"
                type="flat"
                onClick={props.onClick}
            >
                {translate(`si.signals.type.${props.signalType}.add-signal.text`)}
            </IconButton>
        </StyledAddSignalButtonWrapper>
    );
};

export default AddSignalButton;
